import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { APP_SNACKBAR_EVENT } from '../utils/appSnackbar';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AppSnackbar = () => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    useEffect(() => {
        const handleShowSnackbar = (event) => {
            const { message, severity = 'success' } = event.detail || {};
            setSnackbar({ open: true, message, severity });
        };

        window.addEventListener(APP_SNACKBAR_EVENT, handleShowSnackbar);
        return () => window.removeEventListener(APP_SNACKBAR_EVENT, handleShowSnackbar);
    }, []);

    return (
        <Snackbar
            open={snackbar.open}
            autoHideDuration={3000}
            onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
                severity={snackbar.severity}
                sx={{ width: '100%' }}
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
    );
};

export default AppSnackbar;
